import React, { useEffect, useState } from 'react';
import styles from './calendarBoxAlfaLaval.css';
import { useSelector, useDispatch } from 'react-redux';
import { setLocalizationLangs } from 'data/localization/actions';
import { getLangCodeById, getSwitchClassNameOrColourWithBackground } from '../../../../../../utils/func';
import moment from 'moment';


/***********************************************************************************************************************
 *
 * @returns {string}
 **********************************************************************************************************************/

const printDate = ( date ) => {
    const currentDate = date !== null ? date : new Date();
    const now = moment( currentDate );
    const month = now.format( 'MMMM' ).slice( 0, 3 ) + '. ';
    const day = now.format( 'DD' );
    return `${ month } ${ day }`;
};

/**
 *
 * @type {React.NamedExoticComponent<{calendar?: *, index?: *, hatch?: *, calendarPlayerActions?: {setLocalizationLangs: *}, content?: *, handleHatchOpen?: *}>}
 */

const CalendarBoxAlfaLaval = React.memo( ( { hatch,  handleHatchOpen } ) => {

    const [ lang_id, setLang_id ] = useState( null );
    const [ typeTitle, setTypeTitle ] = useState( '' );
    const [ hover, setHover ] = useState( false );
    const { calendar, localization: { content } } = useSelector( ( state ) => state );

    const dispatch = new useDispatch();

    const langHatch = () => {
        if ( hatch.type === 'default' ) setTypeTitle( hatch.title_type ? hatch.title_type : content.calendar.default );
        if ( hatch.type === 'bonus' ) setTypeTitle( hatch.title_type ? hatch.title_type : content.calendar.bonus );
        if ( hatch.type === 'contest' ) setTypeTitle( hatch.title_type ? hatch.title_type : content.calendar.contest );
        if ( hatch.type === 'final' ) setTypeTitle( hatch.title_type ? hatch.title_type : content.calendar.final );
    };

    const toggleHover = ( val ) => setHover( val );

    useEffect( () => {
        if (
            calendar
            && calendar.lang_id
            && lang_id !== calendar.lang_id
        ) {
            setLang_id( calendar.lang_id );
            dispatch( setLocalizationLangs( getLangCodeById( calendar.lang_id ) ) );
        }

        langHatch();
    }, [ hatch ] );

    const getStyleWrapper = () => {
        if ( hatch.type === 'default' ) return styles.wrapperDefault;
        if ( hatch.type === 'bonus' ) return styles.wrapperBonus;
        if ( hatch.type === 'contest' ) return styles.wrapperContest;
        if ( hatch.type === 'final' ) return styles.wrapperFinal;
    };

    const linkStyle = { backgroundColor: hover ? '#fff' : hatch.background };
    const indexColor = getSwitchClassNameOrColourWithBackground( hatch.background, '#000' , '#fff' );
    const titleColor = getSwitchClassNameOrColourWithBackground( hatch.background, '#030303' , '#fff' );

    const { start_date } = hatch;
    const printDateText = printDate( start_date );

    let backgroundFone = {}, indexStyle = {};
    if ( hatch.door_image !== null ) {
        backgroundFone = { ...linkStyle, backgroundImage: hover ? null : `url(${ hatch.door_image.url })` };
    } else if ( linkStyle ) {
        backgroundFone = linkStyle;
    }
    const isFunctionHandle = ( typeof handleHatchOpen === 'function' ) ? true : false;

    if ( isFunctionHandle ) {
        if ( hatch.door_image !== null && !hover ) {
            indexStyle = { color: '#fff' };
        } else if ( hatch.door_image !== null && hover ) {
            indexStyle = { color: '#000' };
        } else if ( hatch.door_image === null && !hover ) {
            indexStyle = { color: indexColor };
        } else if ( hatch.door_image === null && hover ) {
            indexStyle = { color: '#000' };
        }
    } else {
        indexStyle = { color: '#000' };
    }
    const printIndex = () => {
        if ( hover ) {
            return printDateText;
        }
        if ( hatch.number_hatch ) {
            return '';
        }
        return printDateText;
    };

    return (
        <div className={styles.animationWrap}>
        <div
            onMouseEnter={ () => toggleHover( true ) }
            onMouseLeave={ () => toggleHover( false ) }
            className={ `${ styles.wrapper } ${ isFunctionHandle && getStyleWrapper() }` }
            style={ isFunctionHandle ? { ...backgroundFone } : {
                opacity: .5,
                pointerEvents: 'none',
                backgroundImage: ( hatch.door_image !== null ) ? `url(${ hatch.door_image.url })` : 'none'
            } }
            onClick={ () => isFunctionHandle ? handleHatchOpen( hatch ) : null }
        >
        <span className={ styles.hatchIndex }
              style={ indexStyle }>
            { printIndex() }
        </span>

            <div className={ `${ styles.name } ${ styles[ hatch.type ] }` }
                 style={ hatch.background ? {
                     backgroundColor: hatch.background,
                     color: titleColor
                 } : null }
            >
                { typeTitle }
            </div>
            { hatch.door_image !== null && !hover &&
            <div className={ styles.foneLayer }/>
            }
        </div>
        </div>
    );
} );

export default CalendarBoxAlfaLaval;